import React from "react";

export default function ExpenseFilterBar({ categories, filter, setFilter }) {
  const items = ["all", ...categories];
  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {items.map((c) => (
        <button
          key={c}
          onClick={() => setFilter(c)}
          className={`px-3 py-1.5 text-xs font-mono uppercase tracking-[0.15em] border transition-colors ${
            filter === c
              ? "bg-neutral-900 text-white border-neutral-900"
              : "bg-white border-neutral-300 text-neutral-700 hover:bg-neutral-50"
          }`}
          data-testid={`expense-filter-${c.replace(/\s|&/g, "-")}`}
        >
          {c === "all" ? "All" : c}
        </button>
      ))}
    </div>
  );
}
